import { useQuery } from "@tanstack/react-query";
import { ApiError } from "../../../types/apiError";
import { getProjectDefaults } from "../api/getProjectDefaults";
import { ProjectDefaults } from "types/project/projectDefaults";
import { QUERY_KEYS } from "service/querykeys";

export const useProjectDefaultQuery = (projectUuid?: string) =>
  useQuery<ProjectDefaults, ApiError>({
    queryKey: QUERY_KEYS.PROJECT_DEFAULTS(projectUuid),
    queryFn: () => {
      if (!projectUuid) {
        throw new Error("Missing projectUuid");
      }
      return getProjectDefaults(projectUuid);
    },
    enabled: Boolean(projectUuid),
  });
